// Auth
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

// OIDC Configuration
const oidcConfig = {
    authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_uSZtunVeh",
    client_id: "oo4bjk36vjnivfvos129s46np",
    redirect_uri: window.location.origin + "/callback.html",
    response_type: "code",
    scope: "openid email phone mpg-api/read mpg-api/write",
    // post_logout_redirect_uri: window.location.origin + "/index.html",
    post_logout_redirect_uri: window.location.origin,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: window.location.origin + "/silent-refresh.html"
};

// Create UserManager instance
const userManager = new UserManager(oidcConfig);

// Handle user session management
class AuthService {
    async getUser() {
        try {
            const user = await userManager.getUser();
            
            // If there is a user and access token is expired, try silent refresh with refresh token
            if (user && user.expired) {
                try {
                    // console.log('Attempting silent sign in');
                    const newUser = await userManager.signinSilent();
                    return newUser;
                } catch (error) {
                    // If silent refresh fails (refresh token expired/invalid)
                    console.log('Silent refresh failed:', error);
                    // Redirect to login - don't currently want to do this
                    // await userManager.signinRedirect();
                    return null;
                }
            }
            return user;
        } catch (error) {
            console.error("Error getting user: ", error);
            return null;
        }
    }

    async login() {
        try {
            await userManager.signinRedirect();
        } catch (error) {
            console.error("Error during login: ", error);
        }
    }

    async logout() {
        try {
            const options = {
                extraQueryParams: {
                    client_id: userManager.settings.client_id,
                    logout_uri: userManager.settings.post_logout_redirect_uri,
                    redirect_uri: userManager.settings.post_logout_redirect_uri,
                    response_type: 'code'
                }
            }
            clearSelectedCar()
            await userManager.signoutRedirect(options);
        } catch (error) {
            console.error("Error during logout: ", error);
        }
    }

    async handleCallback() {
        try {
            const user = await userManager.signinRedirectCallback();
            return user;
        } catch (error) {
            console.error("Error handling callback: ", error);
            throw error;
        }
    }
}

// Create auth service instance
const authService = new AuthService();

// Update UI based on authentication state
async function updateUIState() {
    const user = await authService.getUser();
    const signInButton = document.getElementById('signInButton');
    const signOutButton = document.getElementById('signOutButton');
    const usernameDisplay = document.getElementById('username');
    const authLinks = document.querySelectorAll('.auth-link');

    if (user && !user.expired) {
        signInButton.style.display = 'none';
        signOutButton.style.display = 'block';
        if (user.profile["cognito:username"]) username = user.profile["cognito:username"][0].toUpperCase() + user.profile["cognito:username"].slice(1)
        usernameDisplay.textContent = username || user.profile.email;
        authLinks.forEach(link => {
            link.classList.remove('d-none');
        });
    } else {
        signInButton.style.display = 'block';
        signOutButton.style.display = 'none';
        usernameDisplay.textContent = '';
        authLinks.forEach(link => {
            link.classList.add('d-none');
        });
    }
}

// Event handlers for user changes
userManager.events.addUserLoaded(() => {
    updateUIState();
});

userManager.events.addUserUnloaded(() => {
    updateUIState();
});

// API URLs
if (window.location.hostname === "localhost") {
    var sysLevel = 'dev'
} else {
    var sysLevel = 'prod'
}
const apiBaseUrl = `https://qefb3kekp9.execute-api.us-east-1.amazonaws.com/${sysLevel}`

// Load common elements and initialize auth
async function loadCommonElements() {
    try {
        // Load header
        const headerUrl = new URL('../components/header.html', import.meta.url);
        const headerResponse = await fetch(headerUrl);
        const headerHtml = await headerResponse.text();
        document.getElementById('header').innerHTML = headerHtml;

        // Load footer
        const footerUrl = new URL('../components/footer.html', import.meta.url);
        const footerResponse = await fetch(footerUrl);
        const footerHtml = await footerResponse.text();
        document.getElementById('footer').innerHTML = footerHtml;

        // Update active nav link
        const currentPage = window.location.pathname;
        document.querySelectorAll('.nav-link').forEach(link => {
            if (link.getAttribute('href') === currentPage) {
                link.classList.add('active');
            }
        });

        // Initialize auth state
        await updateUIState();

        // Add event listeners for auth buttons
        document.getElementById('signInButton')?.addEventListener('click', () => authService.login());
        document.getElementById('signOutButton')?.addEventListener('click', () => authService.logout());

    } catch (error) {
        console.error('Error loading common elements:', error);
    }
}

// Shared utility functions
function formatDate(date) {
    return new Date(date).toLocaleDateString();
}

function toLocalISOString(date) {
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date - offset * 60000);
    return localDate.toISOString().slice(0, 16); // Returns YYYY-MM-DDThh:mm
}

// Show the alert banner
function showAlert(type, message) {
    // Create alert element
    const alertDiv = document.createElement('div');    alertDiv.className = `alert alert-${type} alert-dismissible fade show`;
    alertDiv.innerHTML = `
        ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `;

    // Insert alert at the top of the main content
    const mainContent = document.querySelector('main');
    mainContent.insertBefore(alertDiv, mainContent.firstChild);

    // Auto-dismiss after X seconds
    setTimeout(() => {
        alertDiv.remove();
    }, 10000);
}

// Cookie handling for saving selected car
function setSelectedCar(carId) {
    localStorage.setItem('selectedCarId', carId);
}

function getSelectedCar() {
    return localStorage.getItem('selectedCarId');
}

function clearSelectedCar() {
    localStorage.removeItem('selectedCarId');
}

// Security: Escape HTML to prevent XSS
// only needed on any innerHTML, textContent auto escapes
// Numbers, Dates are usually safe in innerHTML and don't need escaping
function escapeHtml(unsafe) {
    if (unsafe == null) return '';
    return unsafe
        .toString()
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}



// Export necessary functions and objects
export {
    authService,
    userManager,
    loadCommonElements,
    updateUIState,
    apiBaseUrl,
    handleApiError,
    formatDate,
    toLocalISOString,
    showAlert,
    setSelectedCar,
    getSelectedCar,
    escapeHtml
};

document.addEventListener('DOMContentLoaded', loadCommonElements);
